import "./Markets.css";
import "./MarketsResponsive.css";
import { useLoadMarkets } from "../../hooks/useLoadMarkets";
import Slider from "../../widgets/slider/Slider";
import { SwiperSlide } from "swiper/react";
import { useEffect, useState } from "react";
import { useAppContext } from "../../App";

function Markets() {
  const context = useAppContext();
  const marketPartners: Record<string, string> = useLoadMarkets();
  const [items, setItems] = useState<Record<string, string>>({});
  const [slidesPerView, setSlidesPerView] = useState<number | null>();

  useEffect(() => {
    setItems(marketPartners);
  }, [marketPartners]);

  const adjustSlides = (): number => {
    if (context?.innerWidth! < 576) {
      return 1;
    } else if (context?.innerWidth! < 722) {
      return 2;
    } else if (context?.innerWidth! < 940) {
      return 3;
    } else {
      return 4;
    }
  };

  return (
    <div className="markets">
      <div className="d-block">
        <h1 className="text-center">Trusted By The Best</h1>
      </div>
      <div className="d-block">
        <Slider
          config={{
            isAutoPlay: true,
            slidesPerView: adjustSlides(),
            spaceBetween: 20,
            centeredSlides: false,
            navigation: false,
            loop: true,
            swiperClass: "markets-swiper",
            speed: 800,
            autoPlay: {
              delay: 2000,
              disableOnInteraction: false,
            },
          }}
        >
          {Object.entries(items)?.map(([key, value]) => {
            return (
              <SwiperSlide key={key} className={"market-partner-logo"}>
                <img
                  src={value}
                  alt={key}
                  onContextMenu={(e) => e.preventDefault()}
                />
              </SwiperSlide>
            );
          })}
        </Slider>
      </div>
    </div>
  );
}

export default Markets;
